export function WhatIsSellerFinancing() {
  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            What Is Seller Financing for Apartment Buildings?
          </h2>
          <p className="text-xl text-gray-600 max-w-4xl mx-auto leading-relaxed">
            Understanding the fundamentals of owner-financed real estate transactions and how they benefit both sellers and buyers
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/ec6fcb1d6fca0eec6dbf4606258e71d7.jpg"
              alt="Seller financing agreement handshake between property owner and buyer"
              className="w-full h-96 object-cover object-top rounded-lg shadow-lg"
            />
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              The Seller Becomes the Bank
            </h3>
            <p className="text-lg text-gray-700 mb-4 leading-relaxed">
              Seller financing, also known as owner financing or seller carry-back financing, is a real estate transaction where the property seller acts as the lender instead of the buyer obtaining a traditional mortgage from a bank or financial institution. In this arrangement, the seller extends credit to the buyer, allowing them to purchase the apartment building through installment payments over time.
            </p>
            <p className="text-lg text-gray-700 mb-4 leading-relaxed">
              Rather than receiving the full purchase price at closing, the seller receives a down payment (typically 10-30% of the purchase price) and then collects monthly payments that include both principal and interest over an agreed-upon term, usually 5-30 years. The seller retains a lien on the property until the loan is fully paid, providing security and legal recourse if the buyer defaults.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              This financing method has become increasingly popular in the commercial real estate market, particularly for apartment buildings, because it offers significant advantages to both parties. Sellers can generate passive income, defer taxes, and command higher prices, while buyers gain access to financing that may be unavailable through traditional channels.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
            How Seller Financing Works: The Process
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">1. Negotiate Terms</h4>
              <p className="text-gray-600 leading-relaxed">
                Buyer and seller agree on purchase price, down payment, interest rate, loan term, and payment schedule
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">2. Down Payment</h4>
              <p className="text-gray-600 leading-relaxed">
                Buyer provides down payment at closing, typically 10-30% of purchase price, demonstrating commitment
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">3. Monthly Payments</h4>
              <p className="text-gray-600 leading-relaxed">
                Buyer makes regular monthly payments including principal and interest directly to the seller
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3">4. Lien Protection</h4>
              <p className="text-gray-600 leading-relaxed">
                Seller maintains legal lien on property until loan is paid in full, ensuring security and control
              </p>
            </div>
          </div>

          <div className="mt-12 bg-amber-50 border-l-4 border-amber-500 p-6 rounded-md">
            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-alert-line text-3xl text-amber-600"></i>
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-bold text-gray-900 mb-2">Important Disclosure</h4>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Every tax and financial situation is different.</strong> The benefits and strategies discussed on this page may not apply to your specific circumstances. Tax laws are complex and vary by state, property type, holding period, and individual financial situation. Always consult with a qualified tax advisor, CPA, or financial professional before making any decisions about seller financing or structuring your apartment building sale. This information is for educational purposes only and should not be considered tax, legal, or financial advice.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}